import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ErweiterungConfigResponse } from '../../../../core/base-api';
import { FormatConfigService } from '../../../../core/services/format-config.service';
import { GrundstueckId } from '../../../../core/av-api';
import { HaengigeGbGeschaefteComponent } from '../haengige-gb-geschaefte/haengige-gb-geschaefte.component';
import { HaengigeGeoGeschaefteComponent } from '../haengige-geo-geschaefte/haengige-geo-geschaefte.component';
import { HaengigeAuftraegeComponent } from '../haengige-auftraege/haengige-auftraege.component';
import { TranslatePipe } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import ActiveErweiterungenEnum = ErweiterungConfigResponse.ActiveErweiterungenEnum;

@Component({
  selector: 'cap-haengige-geschaefte-auftraege',
  templateUrl: './haengige-geschaefte-auftraege.component.html',
  styleUrls: ['./haengige-geschaefte-auftraege.component.scss'],
  imports: [HaengigeGbGeschaefteComponent, HaengigeGeoGeschaefteComponent, HaengigeAuftraegeComponent, TranslatePipe]
})
export class HaengigeGeschaefteAuftraegeComponent implements OnInit, OnDestroy {
  @Input()
  perimeter: Array<GrundstueckId>;
  @Input()
  loadOption = 'HAENGIGE';
  @Input()
  hasRight = true;
  @Input()
  showAuftraege = true;

  auftragsmodul = false;
  private subscription: Subscription = new Subscription();

  constructor(private appFormatConfigService: FormatConfigService) {}

  ngOnInit() {
    if (this.showAuftraege) {
      this.subscription.add(
        this.appFormatConfigService.erweiterungsConfig$.subscribe((config) => {
          this.auftragsmodul = config?.activeErweiterungen.includes(ActiveErweiterungenEnum.AUFTRAGS_MODUL);
        })
      );
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
